module.exports = __webpack_public_path__ + "static/media/tale.cafff1d6.jpg";